import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1000,
    color: "#fff",
  },
}));

export default function Loading({ open }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backdrop} open={open}>
      <img
        src="https://qerp-public.s3.sa-east-1.amazonaws.com/static/gifs/loading-new-blue.gif"
        alt="Loading"
        className={classes.gif}
      />
    </Backdrop>
  );
}
